import type { MouseEvent } from 'react';
import type { OrderStatusId } from '@witmetrics/utils';
import { ORDER_STATUSES } from '@witmetrics/utils/constants';
import Menu, { MenuItem, type MenuProps } from '@/components/Menu';
import OrderStatusCircle from '@/components/OrderStatusCircle';
import { classes } from './utils';

export interface OrderStatusMenuProps extends MenuProps {
  onChange: (orderStatusId: OrderStatusId) => void;
}

export default function OrderStatusMenu({
  open,
  anchorTo,
  anchorOrigin,
  transformOrigin,
  onChange,
  onClose,
}: OrderStatusMenuProps) {
  const handleChange = (e: MouseEvent, orderStatusId: OrderStatusId) => {
    e.preventDefault();
    e.stopPropagation();
    onChange(orderStatusId);
    onClose();
  };

  return (
    <Menu
      anchorTo={anchorTo}
      open={open}
      className={classes.menu}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={onClose}>
      <ul>
        {Object.values(ORDER_STATUSES).map((status) => (
          <MenuItem
            key={status.id}
            label={status.label}
            icon={
              <OrderStatusCircle
                className={classes.icon}
                orderStatusId={status.id}
                size={18}
              />
            }
            onClick={(e) => handleChange(e, status.id)}
          />
        ))}
      </ul>
    </Menu>
  );
}
